package top.wcpe.allincore.ui.runtime.theme

/**
 * Toast 控件主题令牌（ADR-0048 内部分组）。
 *
 * 由 [ControlTheme] 内部持有，`ControlTheme.defaultToastStyle` / `toastStyles` accessor 与
 * `resolveToastStyle` 委托至此——签名不变、消费者零改动。
 *
 * 解析逻辑 [resolve] 随数据下沉至本类（行为随数据、提升内聚），避免 holder 沦为贫血数据袋。
 * 默认值与原 `ControlTheme.Builder` 一致（零回归）。
 */
data class ToastTokens(
    val defaultStyle: ToastStyle = ToastStyle.builder().build(),
    val styles: Map<String, ToastStyle> = emptyMap(),
) {
    /**
     * 按 name 查命名样式；不存在返回 [defaultStyle]。大小写敏感，表项缺失时不抛异常。
     */
    fun resolve(name: String?): ToastStyle {
        if (name.isNullOrEmpty()) return defaultStyle
        return styles[name] ?: defaultStyle
    }
}
